import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { CollapseContent } from '../../../../../../../components/Collapse/CollapseContent'
import { RouteColumn, RouteRow } from '../../../../../../../components/layout'
import { NumberInput, SelectInput, TextInput } from '../../../../../../../components/layout/form/input'
import { FinishedDateTimeInput } from '../../../../../../../components/layout/form/input/DateTimeInput'
import { format } from 'date-fns'
import { Time } from '../../../../../../../types/time'
import { TowingRecordJobStatus } from '../../../../../../../common/types'
import { paymentTypeOptions } from '../../../../../../../components/ALSubForm/options'
import { ServiceType } from '../../../../../../../functions/graphqlApi/types/jobDetails'
import { Modal } from '../../../../../../../components/Modal'
import { ALProps, FinishedAtBreakdownLocationProps } from './FinishedForm'
import { AlArcCodesForm } from '../../../../../../../components/AlArcCodesForm'
import { routeSubformMessages } from '../../messages'

export const FinishedAtBreakdownLocationFormAL: React.FunctionComponent<FinishedAtBreakdownLocationProps & ALProps> = ({
  setValue,
  action,
  getValue,
  translatedServiceTypeOptions,
  batteryServiceOptions,
  autoliittoFields,
}) => {
  const intl = useIntl()
  const [showModal, setShowModal] = useState(false)
  const [edit, setEdit] = useState<boolean>(action === 'edit-finished')
  const causeIsRequired = getValue('serviceType') !== ServiceType.TOWING

  const [warned, setWarned] = useState(() => {
    if (autoliittoFields.hasFinishRouteInfo) return false
    return true
  })

  useEffect(() => {
    if (action === 'edit-finished') {
      if (!edit) setEdit(true)
    } else {
      if (edit) setEdit(false)
    }
  }, [edit, action, setEdit])

  return (
    <CollapseContent>
      {showModal && (
        <Modal
          label={intl.formatMessage(routeSubformMessages.attention)}
          closeLabel={intl.formatMessage(routeSubformMessages.cancelModal)}
          disableCloseOnConfirm
          message={intl.formatMessage(routeSubformMessages.nonTowingServiceWarningMessage)}
          onConfirm={() => {
            setShowModal(false)
          }}
          close={() => {
            setShowModal(false)
            setValue('serviceType', 'towing')
          }}
        />
      )}
      <RouteRow columns={`1fr 1fr 1fr`}>
        <RouteColumn>
          <SelectInput
            label={intl.formatMessage(routeSubformMessages.action)}
            name="serviceType"
            options={translatedServiceTypeOptions}
            onChange={value => {
              if (!warned && value !== 'towing') {
                setWarned(true)
                setShowModal(true)
              }
              setValue('serviceType', value)
            }}
            disabled={!edit}
            required
          />
        </RouteColumn>
        <RouteColumn>
          <NumberInput
            label={intl.formatMessage(routeSubformMessages.odometerReading)}
            name="automobileAndTouringClubFinland.vehicleMileage"
            decimals={0}
            disabled={!edit && autoliittoFields.disableVehicleMileage}
            required={causeIsRequired}
          />
        </RouteColumn>
        <RouteColumn>
          <FinishedDateTimeInput
            name="arrivalRoute"
            label={intl.formatMessage(routeSubformMessages.completionTime)}
            customOnChange={() => {
              const value = (format(new Date(), 'HH:mm') as unknown) as Time
              setValue('arrivalRoute.finishedTime', value)
              setValue('arrivalRoute.finishedDate', new Date())
            }}
            required
            disabled={!edit}
            showCurrentTimeBtn
          />
        </RouteColumn>
      </RouteRow>
      <RouteRow columns={'1fr 1fr 1fr'}>
        <AlArcCodesForm
          serviceType={getValue("serviceType")}
          disableArcComponent={!edit && autoliittoFields.disableArcComponent}
          disableArcDescription={!edit && autoliittoFields.disableArcDescription}
          componentRequired={getValue('serviceType') === ServiceType.ROAD_SERVICE}
          descriptionRequired={getValue('serviceType') === ServiceType.ROAD_SERVICE}
        />
      </RouteRow>
      {getValue('serviceType') === 'battery_service' && (
        <>
          <RouteRow columns="1fr 1fr 1fr">
            <RouteColumn>
              <SelectInput
                label={intl.formatMessage(routeSubformMessages.deliveredBattery)}
                name="automobileAndTouringClubFinland.batteryService.battery"
                options={batteryServiceOptions}
                required
                searchable
                onChange={e => {
                  if (e !== 'other') {
                    setValue('automobileAndTouringClubFinland.batteryService.deliveredBattery', e)
                  } else {
                    setValue('automobileAndTouringClubFinland.batteryService.deliveredBattery', '')
                  }
                }}
              />
            </RouteColumn>
            <RouteColumn>
              <SelectInput
                label={intl.formatMessage(routeSubformMessages.customerPaymentMethod)}
                name="automobileAndTouringClubFinland.batteryService.paymentType"
                options={paymentTypeOptions}
                required
                disabled={!edit}
              />
            </RouteColumn>
            {getValue('automobileAndTouringClubFinland.batteryService.battery') === 'other' && (
              <RouteColumn>
                <TextInput
                  label={intl.formatMessage(routeSubformMessages.deliveredBatteryOther)}
                  name="automobileAndTouringClubFinland.batteryService.deliveredBattery"
                  required
                  disabled={!edit}
                />
              </RouteColumn>
            )}
          </RouteRow>
        </>
      )}
    </CollapseContent>
  )
}

export const finishedAtDestinationEditableJobStatuses = [TowingRecordJobStatus.finished_at_destination]
